import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthKitProvider } from '@workos-inc/authkit-react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// The redirect URI should point to the /callback route
const redirectUri = window.location.origin + '/callback';

const container = document.getElementById('root');
const root = createRoot(container);

// Check for the required environment variable
if (!process.env.REACT_APP_WORKOS_CLIENT_ID) {
  root.render(
    <React.StrictMode>
      <div>
        <h1>Configuration Error</h1>
        <p>
          The <code>REACT_APP_WORKOS_CLIENT_ID</code> environment variable is missing.
        </p>
        <p>
          This is required for authentication to function. Please add it to your
          deployment environment.
        </p>
      </div>
    </React.StrictMode>
  );
} else {
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <AuthKitProvider
          clientId={process.env.REACT_APP_WORKOS_CLIENT_ID}
          redirectUri={redirectUri}
        >
          <App />
        </AuthKitProvider>
      </BrowserRouter>
    </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
